import { useContext } from "react";
import { DataContext } from "../../../store/data-context";
import styles from "./Section1.module.css";
const Section1 = () => {
  const { section1Data } =
    useContext(DataContext);

  return (
    <section
      className={styles["main-section__1"]}
    >
      {section1Data.map((data) => {
        return (
          <div
            key={data.id}
            className={
              styles["main-section__1__services"]
            }
          >
            <div id={styles.image}>
              <img
                src={data.image}
                alt={data.title}
              />
            </div>

            <h2>{data.title}</h2>
            <p>{data.description}</p>
          </div>
        );
      })}
    </section>
  );
};

export default Section1;
